module.exports = __webpack_public_path__ + "img/ski_jacket.580b6d18.png";